import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import InputAdornment from '@material-ui/core/InputAdornment';
import {getFormData, inputChangedHandler, prepareFormData, validateForm} from "../../shared/utility";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import EmailIcon from "@material-ui/icons/Email";
import {connect} from "react-redux";
import * as actions from "../../store/actions";


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
}));


let formData = {
    controls: {
        email: {
            label: 'Email Address',
            value: '',
            validation: {
                presence: {
                    allowEmpty: false
                }, 
                email: true
            },
            valid: false,
            touched: false,
        },
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}


const ForgotPassword = (props) => {

    const classes = useStyles();
    const history = useHistory();
    formData = prepareFormData(formData);
    const [formState, setFormState] = useState(formData);

    const submitHandler = async (event) => {
        event.preventDefault();
        if (!validateForm(formState, setFormState)) {
            return ;
        }
        const data = getFormData(formState)
            props.onForgotPassword(data.email, (err, redirect) => {
                if (err) {
                    console.error(err);    
                    return ;
                }

                if (redirect) {
                    props.onAuthErrorReset();
                    history.push(redirect)
                }

            })
    }

    const emailField = formState.controls.email;


    return (
        <React.Fragment>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div>
                    <TextField
                        name='email'
                        value={emailField.value}
                        type='email'
                        placeholder='Email Address'
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, 'email')}
                        helperText={emailField.helperText}
                        error={!emailField.valid && emailField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon/>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                {props.error &&
                <div>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }

                <div className={classes.wrapper}>
                    <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"}
                        className="LoginButton"
                            disabled={props.loading}> Reset Password</Button>
                    {props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                </div>
            </form>
        </React.Fragment>
    );
}
const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onForgotPassword: (email, onRedirect) => dispatch(actions.forgotPassword(email, onRedirect)),
        onAuthErrorReset: () => dispatch(actions.authStop())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
